/* istanbul ignore if */
define('common/login-state', [
    'react',
    'react-dom',
    'components/login',
    'jquery',
    'jquery.cookie',
], (React, ReactDOM, { Login }, $) => {
    if (typeof window.__karma__ !== 'undefined') {
        $('body').html('<div id="login"></div>');
    }

    const ndLogin = document.getElementById('login');
    if (!ndLogin) {
        return {};
    }

    // 初始化一个loginComponent
    const loginComponent = ReactDOM.render(React.createElement(Login, {
        RRC: window.RRC,
        showRules: true,
    }), ndLogin);

    // 是否登录
    function isLoggedIn() {
        return loginComponent.state.isLogged && !!$.cookie('rrc_login_token');
    }

    // 设置登录状态下才执行的回调
    const switchToLogin = (cb, state = {}) => {
        // 已登录，直接执行后续操作
        if (isLoggedIn()) {
            cb($.cookie('rrc_login_token'));
            return;
        }

        // 未登录，弹出登录弹窗，并将登录完成后的回调注册上
        loginComponent.showLogin();
        loginComponent.setState(Object.assign({
            onLogin: cb,
        }, state));
    };

    // 设置登出后的回调
    const logOutCallBack = (cb) => {
        loginComponent.setState({
            onLogout: cb,
        });
    };

    // 卖车页处理防灌输数据
    const saleCarOutCallBack = (cb, phone, state = {}) => {
        $.removeCookie('rrc_login_phone');
        $.removeCookie('rrc_login_token');
        loginComponent.setState({ isLogged: false, phone });
        $('body').trigger('logout');
        loginComponent.showLogin();
        loginComponent.setState(Object.assign({
            onLogin: cb,
        }, state));
    };

    return {
        loginComponent,
        isLoggedIn,
        switchToLogin,
        logOutCallBack,
        saleCarOutCallBack,
    };
});
